import { Record } from 'immutable';
import { schema } from 'normalizr';

export const CustomerPreference = new Record({
  id: undefined,
  days_before_offline_alarm: undefined,
  digital_virtual_site_group: undefined,
  site_group_schema: {},
  site_schema: {},
  customer: undefined,
});

export const customerPreferenceSchema = new schema.Entity('customerPreferences');

// for reading in nested models, object with { field: schema }
// customerPreferenceSchema.define({  });
